import React from 'react';
import { XCircleIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
const painPoints = ['Domingo a la noche buscando actividades que nunca quedan bien', 'Clases improvisadas porque no tenés secuencia ni estructura clara', 'Laboratorio a las corridas sin guía de registro ni protocolo listo', 'Evaluaciones inventadas porque no tenés rúbricas ni criterios armados', 'Horas perdidas armando material que al año siguiente vas a rehacer igual'];
export function PainPointsSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-212">
      <div className="max-w-4xl mx-auto" data-id="element-213">
        <h2 className="text-3xl md:text-4xl font-black text-center text-brand-dark mb-12" data-id="element-214">
          Si sos docente de Química en secundaria,{' '}
          <br className="hidden md:block" data-id="element-215" />
          <span className="text-brand-orange" data-id="element-216">
            esto te va a sonar familiar:
          </span>
        </h2>

        <div className="space-y-6 mb-12 bg-red-50 p-8 rounded-2xl border border-red-100" data-id="element-217">
          {painPoints.map((point, index) => <div key={index} className="flex items-start gap-4" data-id="element-218">
              <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-219" />
              <p className="text-xl font-medium text-gray-800" data-id="element-220">{point}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-221">
          <h3 className="text-2xl md:text-3xl font-bold text-brand-dark mb-8" data-id="element-222">
            ¿Cuántos domingos más vas a perder haciendo lo mismo?
          </h3>
          <div className="max-w-xl mx-auto" data-id="element-223">
            <CTAButton text="→ QUIERO DEJAR DE IMPROVISAR" href="#compra" data-id="element-224" />
          </div>
        </div>
      </div>
    </section>;
}